<template>
  <div>
    <v-tooltip location="bottom">
      <template #activator="{ props }">
        <div v-bind="props">
          <v-btn-icon
            icon="mdi-code-tags"
            :class="[{ 'px-5': $vuetify.display.sm }, { 'px-4': $vuetify.display.xs }]"
            data-testid="generateCodeItem.menu-button"
            @click.stop="generator_Dialog = true"
          >
          </v-btn-icon>
        </div>
      </template>
      <span>Generate Code</span>
    </v-tooltip>
    <generator-dialog :value="generator_Dialog" :statechart-name="statechartName" @cancel="generator_Dialog = false" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import GeneratorDialog from "./GeneratorDialog.vue";

defineProps<{ statechartName: string }>();

const generator_Dialog = ref(false);
</script>

<style scoped></style>
